import { MtopAdapter } from "./runtime";
export var mtopInterceptor = [function (config) {
  var _ref, _ref$getContentType;
  if (!/^mtop\./.test(config.url || '')) {
    return config;
  }
  var contentType = (_ref = config.headers || undefined) === null || _ref === void 0 || (_ref$getContentType = _ref.getContentType) === null || _ref$getContentType === void 0 ? void 0 : _ref$getContentType.call(_ref);

  // @ts-ignore
  if (contentType !== void 0 && contentType !== 'application/json') {
    // Only JSON is supported
    return config;
  }
  config.adapter = MtopAdapter;
  return config;
}];
export var mtopResponseInterceptor = function mtopResponseInterceptor(e) {
  if (e.type === 'MtopError') {
    var _e$data;
    if (e.retType === 'FAIL_SYS_SESSION_EXPIRED' || ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.code) === 601) {
      // 统一登录态处理逻辑
      location.reload();
      return;
    }

    // 这样写避免被Babel、Webpack等插件优化去除
    var _console = console,
      error = _console.error;
    error(e);
  }
};